import { render } from "./design-button.vue?vue&type=template&id=7ff7d148"
import script from "./design-button.vue?vue&type=script&lang=js"
export * from "./design-button.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_admin_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__